// Display title for a notebook page. Untitled is the server default.
export function notebookLabel(page) {
  const title = page?.title?.trim()
  return title || 'Untitled'
}
